export const LoginPageModes = {
  Login: "login",
  SendVerificationCode: "send-verification-code",
  CheckVerificationCode: "check-verification-code",
  ChangePassword: "change-password",
};
